import { render, staticRenderFns } from "./Ajuste_Stock.vue?vue&type=template&id=be6c068c&scoped=true"
import script from "./Ajuste_Stock.vue?vue&type=script&lang=js"
export * from "./Ajuste_Stock.vue?vue&type=script&lang=js"
import style0 from "./Ajuste_Stock.vue?vue&type=style&index=0&id=be6c068c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6c068c",
  null
  
)

export default component.exports